/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StudentLoginDto } from '../../models/student-login-dto';
import { StudentToken } from '../../models/student-token';

export interface IlsControllerStudentLogin$Params {
  ilsId: string;
      body: StudentLoginDto
}

export function ilsControllerStudentLogin(http: HttpClient, rootUrl: string, params: IlsControllerStudentLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentToken>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerStudentLogin.PATH, 'post');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StudentToken>;
    })
  );
}

ilsControllerStudentLogin.PATH = '/ils/{ilsId}/login';
